import { DateTime } from '@ksyos/date-time';
import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { RequestReadButtons } from '../../../../elements/carePathButtons/RequestReadButtons';
import { UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { FormSection } from '../../../../elements/forms/formSection/FormSection';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemFooter } from '../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';
import { ProfileImages } from '../../utils/v1/ProfileImages';
import { GgzoIntV1FollowingSteps } from './GgzoIntV1FollowingSteps';

export function GgzoIntV1RequestRead(props: ICustomControlRequestReadProps) {
    return (
        <ProcessContainer isActiveActivity={props.itemState.initialIsOpen}>
            <ProcessItemHeader
                date={props.process.dateSent || (props.request && props.request.dateSent)}
                isExaminationRequest
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => {
                    await props.updateItemState({
                        ...props.itemState,
                        isOpen: isOpened || !!props.itemState.initialIsOpen,
                    });
                }}
                organizationName={props.process.requesterOrganization?.name}
                practitionerName={
                    props.process.requesterPractitioner
                        ? getDisplayName(props.process.requesterPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={props.process.serviceType}
                title={getServiceLabel(props.process.code, 'request', props.process.name)}
            />

            <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                <FormSection>
                    <ProfileImages
                        alternativeLabelText={'professionEnum.generalPractitioner'}
                        organization={props.request.draftCareProviderOrganization}
                        practitioner={props.request.draftCareProviderPractitioner}
                        request={props.request}
                        showAlsoWhenNotRequested
                    />
                </FormSection>

                {props.request.customControlData.emailadres && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('interapy.patientEmail')}</FormLabel>
                        <InputContainer>
                            <UserTextParagraph>{props.request.customControlData.emailadres}</UserTextParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}

                {(props.request.selectedDiagnosticReportProviderPractitionerId ||
                    props.request.selectedDiagnosticReportProviderOrganizationId) && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{translateKey('request.sentTo')}</FormLabel>
                        <InputContainer>
                            <UserTextParagraph>
                                {props.request.selectedDiagnosticReportProviderPractitionerId
                                    ? getDisplayName(props.request.selectedDiagnosticReportProviderPractitioner!)
                                    : props.request.selectedDiagnosticReportProviderOrganization!.name}
                            </UserTextParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}

                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('interapy.sendPostMeasurement')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{getNameting()}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>

                <ProfileImages request={props.request} />
                <GgzoIntV1FollowingSteps />
                <RequestReadButtons {...props} />
            </CustomControlCollapseBody>

            <ProcessItemFooter
                isItemOpen={props.itemState.isOpen}
                labelLess={translateKey('request.hideRequest')}
                labelMore={translateKey('request.showRequest')}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
            />
        </ProcessContainer>
    );

    function getNameting() {
        if (
            props.request.customControlData.heeftNameting &&
            props.request.customControlData.nameting &&
            props.request.customControlData.nametingOp
        ) {
            return `Ja, na ${props.request.customControlData.nameting} ${
                props.request.customControlData.nameting === 1 ? 'week' : 'weken'
            } (${DateTime.from(props.request.customControlData.nametingOp).format('D MMMM YYYY')})`;
        }

        return 'Nee';
    }
}
